import { ShieldCheck, Globe, Database, LogOut } from "lucide-react";
import { Btn, PageHead } from "../components";

export default function SettingsPage({ user, onLogout }) {
  return (
    <div data-testid="admin-settings">
      <PageHead title="SETTINGS" sub="Account and environment." />
      <div className="grid md:grid-cols-2 gap-4 max-w-4xl">
        <div className="border border-woodborder bg-card/40 p-6">
          <div className="flex items-center gap-3 mb-4">
            <ShieldCheck size={18} className="text-gold-bright" />
            <p className="font-mono text-[10px] tracking-[0.25em] text-tan">ADMIN ACCOUNT</p>
          </div>
          <p className="font-editorial font-bold text-cream" data-testid="settings-admin-email">{user?.email}</p>
          <p className="mt-1 font-mono text-[10px] tracking-[0.15em] text-clay">ROLE: ADMINISTRATOR</p>
          <p className="mt-3 text-sand text-sm font-light">Credentials are managed via server environment. Sessions expire after 12 hours.</p>
          <div className="mt-5">
            <Btn variant="danger" onClick={onLogout} data-testid="settings-logout"><LogOut size={13} /> LOG OUT</Btn>
          </div>
        </div>
        <div className="border border-woodborder bg-card/40 p-6">
          <div className="flex items-center gap-3 mb-4">
            <Globe size={18} className="text-tan-light" />
            <p className="font-mono text-[10px] tracking-[0.25em] text-tan">DOMAIN</p>
          </div>
          <p className="text-sand text-sm font-light">
            The CMS and public site are domain-independent. When the production Cobain Report domain connects, both keep working — no rebuild needed.
          </p>
        </div>
        <div className="border border-woodborder bg-card/40 p-6 md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <Database size={18} className="text-burnt-hover" />
            <p className="font-mono text-[10px] tracking-[0.25em] text-tan">INTEGRATIONS READINESS</p>
          </div>
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-2 text-sm text-sand font-light" data-testid="settings-integrations">
            <p>— Media storage: <span className="text-gold-bright">ACTIVE</span> (uploads live on object storage, served via CDN-ready URLs)</p>
            <p>— YouTube: <span className="text-gold-bright">ACTIVE</span> (auto-pulls latest episode hourly)</p>
            <p>— Stripe checkout: <span className="text-clay">ARCHITECTURE READY — OFF</span></p>
            <p>— Printful fulfillment: <span className="text-clay">ARCHITECTURE READY — OFF</span></p>
            <p>— Email provider (Brevo/Mailchimp): <span className="text-clay">EXPORT CSV FOR NOW</span></p>
            <p>— Cobain Streaming: <span className="text-clay">COMING SOON</span></p>
          </div>
        </div>
      </div>
    </div>
  );
}
